enum TimeUnits {
  Minute = "min",
  Hour = "hour",
  Second = "sec",
}

const getTimeString = (quantity: number, unit: TimeUnits) => {
  const plural = quantity === 1 ? `` : `s`;
  return `${quantity} ${unit}${plural}`;
};

export const getTimeRemainingString = (
  totalSecondsExact: number
): string | null => {
  if (isNaN(totalSecondsExact)) {
    return null;
  }

  const totalSeconds = Math.max(0, Math.round(totalSecondsExact));
  const remainingSeconds = totalSeconds % 60;
  const totalMinutes = (totalSeconds - remainingSeconds) / 60;
  const remainingMinutes = totalMinutes % 60;
  const totalHours = (totalMinutes - remainingMinutes) / 60;

  let output = getTimeString(remainingMinutes, TimeUnits.Minute);
  if (totalHours > 0) {
    output = `${getTimeString(totalHours, TimeUnits.Hour)} and ${output}`;
  } else {
    output += ` and ${getTimeString(remainingSeconds, TimeUnits.Second)}`;
  }

  return output;
};
